/**
 * Hooks for the menu activity tab
 */

import { useEffect, useState } from "react";
import activityLogsApiService from "./activityLogsApiService";
import {
    ActivityRange,
    DailyActivityStat,
    DownloadStat,
    MenuStat,
    UserActivityStat,
    UserMenuStat,
} from "./types";

export interface ActivityStats {
    daily: DailyActivityStat[];
    topMenus: MenuStat[];
    topUsers: UserActivityStat[];
    topDownloads: DownloadStat[];
}

const errorMessage = (err: unknown) => (err instanceof Error ? err.message : "Gagal memuat data aktivitas");

export function useActivityStats(range: ActivityRange) {
    const [data, setData] = useState<ActivityStats | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);

        Promise.all([
            activityLogsApiService.getDaily(range),
            activityLogsApiService.getTopMenus(range),
            activityLogsApiService.getTopUsers(range),
            activityLogsApiService.getTopDownloads(range),
        ])
            .then(([daily, topMenus, topUsers, topDownloads]) => {
                if (!cancelled) setData({ daily, topMenus, topUsers, topDownloads });
            })
            .catch((err) => {
                if (!cancelled) setError(errorMessage(err));
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [range]);

    return { data, loading, error };
}

export function useUserMenus(range: ActivityRange, email: string | null) {
    const [data, setData] = useState<UserMenuStat[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!email) {
            setData([]);
            return;
        }
        let cancelled = false;
        setLoading(true);
        setError(null);

        activityLogsApiService
            .getUserMenus(range, email)
            .then((rows) => {
                if (!cancelled) setData(rows);
            })
            .catch((err) => {
                if (!cancelled) setError(errorMessage(err));
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [range, email]);

    return { data, loading, error };
}
